export default class Banner {
  constructor(public imageDesktop: string = '', public imageMobile: string = '', public link: string = '') {}
}
